import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rich-text" }
const _hoisted_2 = ["innerHTML"]

import { inject } from 'vue';

  interface ComponentProps {
    content?: string;
  }
  interface IProps {
    props: ComponentProps,
    modelValue?: boolean;
  }
  interface IEmits {
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: ComponentProps): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    props: null,
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: ComponentProps): void;
  }), expose: any, slots: any, attrs: any }) {

  
  
  const editorMode = inject('editorMode');

  const handleRichTextChange = (content: any) => {
    emits('change', { content });
  };


return (_ctx: any,_cache: any) => {
  const _component_AppRichText = _resolveComponent("AppRichText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(editorMode))
      ? (_openBlock(), _createBlock(_component_AppRichText, {
          key: 0,
          content: __props.props.content,
          onChange: handleRichTextChange
        }, null, 8, ["content"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          innerHTML: __props.props.content
        }, null, 8, _hoisted_2))
  ]))
}
}

})